export default "/static/icons/prescription.png"